<!-- Base Date -->
<div class="mt-4 rounded-xl border  flex justify-between gap-x-4 border-b border-gray-900/5 bg-gray-50 p-6 pb-2">
  <span class="text-2xl font-thin">{{ eventAnalysisStore.getEventName() }}</span>
  <div class="grid grid-rows-2">
    @if (eventAnalysisStore.timeRepository._isInitialized) {
      <span class="text-2xl font-medium">
        {{ dateToString(eventAnalysisStore.timeRepository.getStartTime(), eventAnalysisStore.timeRepository.getEndTime()) }}
      </span>
      <span class="text-end font-thin">
        ({{ eventAnalysisStore.timeRepository.getStartTime() | date : "HH:mm" }}
        - {{ eventAnalysisStore.timeRepository.getEndTime() | date : "HH:mm" }} Uhr)
      </span>
    }
  </div>
</div>

<div class="grid  grid-cols-1 xl:grid-cols-2 gap-x-4">


  <div class="row-start-1 xl:col-span-2 mt-3  overflow-hidden  bg-white ">

    <ul class="grid grid-cols-1 gap-x-6 gap-y-8 lg:grid-cols-3 xl:gap-x-8" role="list">
      <li class="overflow-hidden rounded-xl border border-gray-200">
        <div class="flex items-center gap-x-4 border-b border-gray-900/5 bg-gray-50 p-6">
          <svg class="bi bi-graph-up-arrow h-6 w-6 " viewBox="0 0 16 16"
               xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0 0h1v15h15v1H0zm10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4.9l-3.613 4.417a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61L13.445 4H10.5a.5.5 0 0 1-.5-.5"
              fill-rule="evenodd"/>
          </svg>
          <div class="text-sm font-medium leading-6 text-gray-900">Umsatz</div>
          <div class="relative ml-auto">

          </div>
        </div>
        <dl class="-my-3   px-6 py-4 text-sm leading-6">

          <div class="flex justify-between gap-x-4 pt-3">
            <dt class="text-gray-500">Umsatz</dt>
            <dd class="font-medium text-gray-900">{{ eventAnalysisStore.getTotalRevenue() | currency: "EUR" }}</dd>
          </div>
          <table class="w-full border-t-2 border-b-2 border-grey-900" style="padding: .5rem .5rem;">
            <tr class=" ">
              <th class="text-gray-500 ">
                <div class="  px-0">Steuern</div>
              </th>
              <td class="text-right  py-2">
                <div class=" text-gray-900 px-0">{{ -eventAnalysisStore.getTotalTaxes() | currency: "EUR" }}</div>
              </td>
            </tr>
            <tr class="">
              <th class="text-gray-500   ">
                <div class="  px-0">Wareneinsatz</div>
              </th>
              <td class="text-right py-2">
                <div
                  class=" text-gray-900 px-0 ">{{ -eventAnalysisStore.getTotalSourceDetailsCost() | currency: "EUR" }}
                </div>
              </td>
            </tr>
            <tr class="">
              <th class="text-gray-500  ">
                <div class="  px-0">Personalkosten</div>
              </th>
              <td class="text-right py-2">
                <div
                  class=" text-gray-900 px-0 ">{{ -eventAnalysisStore.getTotalEmployeeCosts() | currency: "EUR" }}
                </div>
              </td>
            </tr>
          </table>
          <div class="flex justify-between gap-x-4 py-3">
            <dt class="text-gray-500">vorl. Gewinn</dt>
            <dd class="font-medium text-gray-900">
              = {{ eventAnalysisStore.getTotalRevenue() - eventAnalysisStore.getTotalTaxes() - eventAnalysisStore.getTotalSourceDetailsCost() - eventAnalysisStore.getTotalEmployeeCosts() | currency: "EUR" }}
            </dd>
          </div>
        </dl>
      </li>
      <li class="overflow-hidden rounded-xl border border-gray-200">
        <div class="flex items-center gap-x-4 border-b border-gray-900/5 bg-gray-50 p-6">
          <svg class="bi bi-clipboard2-data h-6 w-6 " height="16" viewBox="0 0 16 16"
               width="16" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9.5 0a.5.5 0 0 1 .5.5.5.5 0 0 0 .5.5.5.5 0 0 1 .5.5V2a.5.5 0 0 1-.5.5h-5A.5.5 0 0 1 5 2v-.5a.5.5 0 0 1 .5-.5.5.5 0 0 0 .5-.5.5.5 0 0 1 .5-.5z"/>
            <path
              d="M3 2.5a.5.5 0 0 1 .5-.5H4a.5.5 0 0 0 0-1h-.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1H12a.5.5 0 0 0 0 1h.5a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5z"/>
            <path
              d="M10 7a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0zm-6 4a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0zm4-3a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1"/>
          </svg>
          <div class="text-sm font-medium leading-6 text-gray-900">Statistiken</div>
          <div class="relative ml-auto">
            <div class="flex place-self-center ">
              <label class="sr-only" for="statitisticSelection">Anzeigeoption</label>
              <select (ngModelChange)="changeOverviewGroupAttribute($event)" [ngModel]="selectedOverviewGroupAttribute"
                      class=" block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      id="statitisticSelection" name="statitisticSelection">
                <ng-container *ngFor="let attribute of overviewGroupAttributes">
                  <option [value]="attribute.key">{{ attribute.description }}</option>
                </ng-container>
                <!--
                <option [value]="SalesDtoKeys.locationId">Umsatz pro
                  Standort
                </option>
                <option [value]="SalesDtoKeys.compositionTypeId"
                >Umsatz pro
                  Kategorie
                </option>
                <option [value]="SalesDtoKeys.bookingType"
                >Umsatz pro
                  Zahlungsmethode
                </option>-->
              </select>
            </div>
          </div>
        </div>
        <dl class="-my-3 px-6 py-4 text-sm leading-6">
          <div class="flex justify-between gap-x-4 py-3">
            <dt class="text-gray-500">Umsatz pro Arbeitsstunde</dt>
            <dd
              class="text-gray-900">{{ eventAnalysisStore.getTotalRevenue() / eventAnalysisStore.getTotalEmployeeHours() | currency: "EUR" }}
            </dd>
          </div>
          <div class="flex justify-between gap-x-4 pb-3">
            <dt class="text-gray-500">Verkaufte Artikel</dt>
            <dd class="text-gray-900">{{ eventAnalysisStore.getSoldArticleCount() }}</dd>
          </div>

          <table class="w-full border-t-2  border-grey-900" style="padding: .5rem .5rem;">
            <ng-container *ngFor="let revenueOfGroup of eventAnalysisStore.revenueByAttributes">
              <tr class=" ">
                <th class="text-gray-500 ">
                  <div class="  px-0">{{ revenueOfGroup.name }}</div>
                </th>
                <td class="text-right  py-2">
                  <div class=" text-gray-900 px-0">{{ revenueOfGroup.revenue | currency: "EUR" }}</div>
                </td>
              </tr>
            </ng-container>
          </table>
        </dl>
      </li>
      <li class="overflow-hidden rounded-xl border border-gray-200">
        <div class="flex items-center gap-x-4 border-b border-gray-900/5 bg-gray-50 p-6">
          <svg class="bi bi-gear h-6 w-6" height="16" viewBox="0 0 16 16" width="16"
               xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492M5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0"/>
            <path
              d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115z"/>
          </svg>
          <div class="text-sm font-medium leading-6 text-gray-900">Einstellungen</div>
          <div class="relative ml-auto">

          </div>
        </div>
        <dl class="-my-3 divide-y divide-gray-100 px-6 py-4 text-sm leading-6">
          <div class="flex justify-between gap-x-4 py-3">
            <dt class="text-gray-500">Netto</dt>
            <dd class="text-gray-700">
              <app-switch-medium (isOnChange)="isNetRevenueChanged($event)" [isOn]="isNetRevenue"
                                 class="my-auto">

              </app-switch-medium>
            </dd>
          </div>
          <div class="flex justify-between gap-x-4 py-3">
            <dt class="text-gray-500">Wareneinsatz gegenrechnen</dt>
            <dd class="text-gray-700">
              <app-switch-medium (isOnChange)="isSourceDetailsCostExcludedChanged($event)"
                                 [isOn]="isSourceDetailsCostExcluded"
                                 class="my-auto">

              </app-switch-medium>
            </dd>
          </div>
          <div class="flex justify-between gap-x-4 py-3">
            <dt class="text-gray-500">Mitarbeiterverkäufe ignorieren</dt>
            <dd class="flex items-start gap-x-2">
              <app-switch-medium (isOnChange)="excludeEmployeeSalesChanged($event)" [isOn]="excludeEmployeeSales"
                                 class="my-auto"></app-switch-medium>
            </dd>
          </div>

          <div class="flex justify-between gap-x-4 py-3">
            <dt class="text-gray-500">Umsatz ohne Mitarbeiterverkäufe</dt>
            <dd class="flex items-start gap-x-2">
              <app-switch-medium (isOnChange)="excludeEmployeeSalesAndKeepSourceDetailCost($event)"
                                 [isOn]="isEmployeeSalesExcludedAndEmployeeSalesSourceDetailsIncluded"
                                 class="my-auto"></app-switch-medium>
            </dd>
          </div>
        </dl>
      </li>
    </ul>
  </div>
  <!--
  <div class="divide-y row-start-1 xl:col-span-2 mt-5 divide-gray-200 overflow-hidden rounded-lg bg-white shadow">
    <div class="px-4 py-2 sm:px-6 text-gray-950  inline-flex justify-between w-full ">
      <div>
        <span class="text-2xl">Zusammenfassung</span>
        <div *ngIf="activeEvent?.name" class="text-xl font-thin block">
          <span>{{activeEvent?.name}}</span>
        </div>
      </div>
      <div class="my-auto ">

        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
             stroke="currentColor" class="w-6 h-6 cursor-pointer " (click)="openSideBar()">
          <path stroke-linecap="round" stroke-linejoin="round"
                d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z"/>
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
        </svg>

      </div>
    </div>
    <div class="px-4  sm:!p-4 ">
      <ul role="list" class="grid grid-cols-1 gap-6 sm:grid-cols-2 ">
        <li class="col-span-1 ">
          <div>
            <div class="mt-6 mx-2  border-gray-100 ">
              <dl class="divide-y divide-gray-100">
                <div class="px-4 py-6 flex gap-4 sm:px-0">
                  <dt class="w-full text-sm font-medium leading-6 text-black">
                    <div class="inline-flex justify-between w-full">
                      <span class=""><strong>Name</strong></span>
                    </div>
                  </dt>
                  <dd
                    class="text-sm leading-6 text-black col-span-2 inline-flex justify-end whitespace-nowrap">{{activeEvent?.name}}</dd>
                </div>
                <div class="px-4 py-6 grid grid-cols-3 gap-2 sm:px-0">
                  <dt class="text-sm font-medium leading-6 text-black">
                    <div class="inline-flex justify-between w-full">
                      <span class=""><strong>Zeitraum</strong></span>
                    </div>
                  </dt>
                  <dd class="mt-1 text-sm leading-6 text-black col-span-2 sm:mt-0"></dd>
                  <dt class="text-sm font-medium leading-6 text-black">
                    <div class="inline-flex w-full">
                      <span>Start:</span>
                    </div>
                  </dt>

                  <dd
                    class=" text-sm leading-6 text-black col-span-2 sm:mt-0 w-full inline-flex justify-end">
                    <div
                      *ngIf="activeEvent?.start">{{activeEvent?.start! | date: globalDateService.getDateformat(GlobalDateFormat.LONG_WITH_TIME)}}</div>
                  </dd>
                  <dt class="text-sm font-medium leading-6 text-black">
                    <div class="inline-flex w-full">
                      <span>Ende:</span>
                    </div>
                  </dt>
                  <dd
                    class=" text-sm leading-6 text-black col-span-2 sm:mt-0 w-full inline-flex justify-end">
                    <div
                      *ngIf="activeEvent?.end">{{activeEvent?.end! | date: globalDateService.getDateformat(GlobalDateFormat.LONG_WITH_TIME)}}</div>
                  </dd>

                </div>
                <div class="hidden sm:flex text-center w-full justify-center pt-3" >
                  <span class="text-gray-500 my-auto pr-2 text-sm">Mitarbeiterverkäufe exkludieren</span>
                  <app-switch-medium class="my-auto" [isOn]="excludeEmployeeSales"
                                     (isOnChange)="excludeEmployeeSalesChanged($event)"></app-switch-medium>
                </div>
                <div class="hidden sm:flex text-center w-full justify-center pt-3" >
                  <span class="text-gray-500 my-auto pr-2 text-sm">Netto</span>
                  <app-switch-medium class="my-auto" [isOn]="excludeEmployeeSales"
                                     (isOnChange)="excludeEmployeeSalesChanged($event)"></app-switch-medium>
                </div>
              </dl>
            </div>
          </div>
        </li>
        <li>
          <div>
            <div class="mt-6 mx-2 border-gray-200 ">
              <dl class="divide-y divide-gray-200">
                <div class="px-4 py-6 flex gap-4 sm:px-0">
                  <dt class="w-full text-sm font-medium leading-6 text-gray-900"><strong>Gesamtumsatz abzgl. Steuer TODO</strong>
                  </dt>
                  <dd
                    class="text-sm leading-6 text-gray-700 text-end">
                    <div *ngIf="activeEvent">{{TaxUtilities.getNetFromGross(eventAnalysisStore.getTotalGrossRevenue(),0.19) | currency: "EUR"}}</div>
                  </dd>

                </div>

                <div class="px-4 py-6 flex gap-4 sm:px-0">
                  <dt class="w-full text-sm font-medium leading-6 text-gray-900"><strong>Gesamtumsatz</strong>
                  </dt>
                  <dd
                    class="text-sm leading-6 text-gray-700 text-end">
                    <div *ngIf="activeEvent">{{eventAnalysisStore.getTotalGrossRevenue() | currency: "EUR"}}</div>
                  </dd>

                </div>
                <div class="px-4 py-6 flex gap-4 sm:px-0">
                  <dt class="w-full text-sm font-medium leading-6 text-gray-900"><strong>Mitarbeiterausgaben</strong>
                  </dt>
                  <dd
                    class="text-sm leading-6 text-gray-700 text-end">
                    -->
  <!--<div >{{employeeCostHandler.totalEmployeeCosts | currency: "EUR"}}</div>-->
  <!--</dd>


</div>
<div class="px-4 py-6 flex gap-4 sm:px-0">
  <dt class="w-full text-sm font-medium leading-6 text-gray-900"><strong>Einkaufspreis</strong>
  </dt>
  <dd
    class="text-sm leading-6 text-gray-700 text-end">
    <div >{{sourceDetailsCostHandler.totalSourceDetailsCosts | currency: "EUR"}}</div>
  </dd>


</div>

<div class="px-4 py-6 flex gap-4 sm:px-0">
  <dt class="w-full text-sm font-medium leading-6 text-gray-900"><strong>Gesamtanzahl an Bestellungen</strong></dt>
  <dd class="text-sm leading-6 text-gray-700 text-end">{{getTotalOrders()}}</dd>
</div>

<div class="px-4 py-6 grid grid-cols-3   sm:px-0" >
  <dt class="col-span-3 text-sm font-medium leading-6 text-black">
    <span class=""><strong>Transaktionstyp</strong></span>
  </dt>
-->
  <!-- Todo: Later
  <ng-container *ngFor="let paymentRevenue of dataTransformers.getRevenueOfPaymentMethod() | keyvalue; index as i">
    <div class="col-span-3 col-start-{{i+10}} flex w-full justify-between">
    <dt class="  text-sm  font-medium leading-6 text-black">
          <span >{{mapPaymentMethodToTranslation(paymentRevenue.key)}}</span>
    </dt>

    <dd
      class=" text-sm leading-6 text-black sm:mt-0">
      <div *ngIf="activeEvent?.start">{{paymentRevenue.value | currency: "EUR"}} ({{ getPercentageOfTotal(paymentRevenue.value)| percent}})</div>
    </dd>
    </div>
  </ng-container>
  -->
  <!--
                  </div>
                  <div class="flex sm:hidden text-center w-full justify-center pt-3 pb-3">
                    <span class="text-gray-500 my-auto  pr-2 text-sm">Mitarbeiterverkäufe exkludieren</span>
                    <app-switch-medium class="my-auto" [isOn]="excludeEmployeeSales"
                                       (isOnChange)="excludeEmployeeSalesChanged($event)"></app-switch-medium>
                  </div>


                </dl>
              </div>
            </div>
          </li>
        </ul>

      </div>
    </div>
  -->


  <div class="xl:col-span-2 row-start-2">
    <!-- BarChart -->
    <analytics-revenue-timeline-chart></analytics-revenue-timeline-chart>
  </div>

  <div class=" xl:col-span-1  row-start-3">
    <!-- PieChart -->
    <app-distribution-chart></app-distribution-chart>


  </div>

  <!-- Sankey -->

  <div
    class="divide-y divide-gray-200 xl:row-start-3 row-start-4 row-span-1 xl:col-span-1 mt-5 xl:max-h-full pb-6 bg-white shadow sm:rounded-lg xl:overflow-y-scroll table-window-container">
    <app-sankey-chart></app-sankey-chart>
  </div>

  <!-- Composition Table -->
  <div
    class=" divide-y  divide-gray-200 xl:row-start-4 row-start-5 row-span-1 xl:col-span-2  mt-5 xl:max-h-full pb-6 bg-white shadow sm:rounded-lg   table-window-container">
    <app-composition-overview-table></app-composition-overview-table>
  </div>


  <!-- Top Sales-->
  <div
    class="mt-5 row-start-6 divide-y divide-gray-200 xl:col-span-2 row-span-1 pb-6 bg-white  shadow sm:rounded-lg overscroll-y-contain">
    <app-top-sales-card></app-top-sales-card>
  </div>
</div>
